import { configureStore } from '@reduxjs/toolkit'
import dealsReducer from './dealsSlice'
import userReducer from './userSlice'
import adminAuthReducer from './adminAuthSlice'
import adminUsersReducer from './adminUsersSlice'
import adminCustomersReducer from './adminCustomersSlice'
import notificationsReducer from './notificationsSlice'
import referralReducer from './referralSlice'
import featuresReducer from './featuresSlice'
import dashboardReducer from './dashboardSlice'
import knowledgeHubReducer from './knowledgeHubSlice'
import assistantReducer from './assistantSlice'

export const store = configureStore({
  reducer: {
    deals: dealsReducer,
    user: userReducer,
    adminAuth: adminAuthReducer,
    adminUsers: adminUsersReducer,
    adminCustomers: adminCustomersReducer,
    notifications: notificationsReducer,
    referral: referralReducer,
    features: featuresReducer,
    dashboard: dashboardReducer,
    knowledgeHub: knowledgeHubReducer,
    assistant: assistantReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state that contain non-serializable values (functions)
        ignoredPaths: ['deals.filterDefinitions']
      }
    })
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
